import { Grid, styled } from '@mui/material';
import React from 'react';
import { CalendarShiftItem } from './calendar-shift-item';

type CalendarDayColumnProps = {
  data: {
    applicants: number;
    claimants: number;
    jobName: string;
    flexPoolOnly: boolean;
    dateLabel: string;
    dateTime: string;
    endTime: string;
    id: string;
    maxClaimants: number;
    startTime: string;
    hasCanceledClaim: boolean;
  }[];
  dayCount: number;
};

export const CalendarDayColumn = React.memo(
  ({ data, dayCount }: CalendarDayColumnProps) => {
    return (
      <ShiftWrapper item dayCount={dayCount}>
        {data.length
          ? data.map((shift) => <CalendarShiftItem key={shift.id} shiftData={shift} />)
          : null}
      </ShiftWrapper>
    );
  },
  (prev, next) => {
    if (prev.data.length !== next.data.length) {
      return false;
    }
    for (let i = 0; i < prev.data.length; i++) {
      if (prev.data[i].id !== next.data[i].id) {
        return false;
      }
      if (JSON.stringify(prev.data[i]) !== JSON.stringify(next.data[i])) {
        return false;
      }
    }
    return true;
  }
);

const ShiftWrapper = styled(Grid, { shouldForwardProp: (prop) => prop !== 'dayCount' })<{
  dayCount: number;
}>(({ theme, dayCount }) => ({
  width: `calc(100% / ${dayCount})`,
  padding: theme.spacing(2),
  '&:last-child': {
    borderRight: 'none',
  },
}));
